import {cmsLoadCopy, cmsLoadDynamicCopy, cmsLoadFlowCopy} from '@actions/cms.action';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CULTURE_CODE_REGEX } from '@constants/app.constants';
import {CmsDynamicFlows, CmsDynamicSubFlows, CmsKeys, FeaturePageKeys, ContentPageKeys} from '@constants/cms.constants';
import { Store } from '@ngrx/store';
import { CoreState } from '@reducers/index';
import { selectIsCultureValidAndEnabled } from '@selectors/router.selector';
import { pathPartToCmsCopyName } from '@utils/data-utils';
import { Observable, filter, map } from 'rxjs';
import {loadDynamicPagesConfig} from "@actions/app.action";

export const cmsFlowDataGuard = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const store = inject<Store<CoreState>>(Store);
  const urlCulture = route.params.culture as string | undefined;
  const isPageWithCulture = !!urlCulture && CULTURE_CODE_REGEX.test(urlCulture);

  return store.select(selectIsCultureValidAndEnabled).pipe(
    filter((isValid) => isValid),
    map(() => {
      route.url.forEach((urlPart) => {
        if (CULTURE_CODE_REGEX.test(urlPart.path)) {
          isPageWithCulture &&
            store.dispatch(cmsLoadFlowCopy({ key: CmsKeys.App }));
          isPageWithCulture &&
            store.dispatch(cmsLoadFlowCopy({ key: CmsKeys.Home }));
        } else {
          store.dispatch(
            cmsLoadFlowCopy({ key: pathPartToCmsCopyName(urlPart.path) }),
          );
        }
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      route.data?.additionalDynamicCmsKeys?.forEach((key: {
        flowKey: CmsDynamicFlows,
        subFlowKey?: CmsDynamicSubFlows
      }) => {
        store.dispatch(cmsLoadDynamicCopy({ flowKey: key.flowKey, subFlowKey: key.subFlowKey }));
      })

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      route.data?.umbracoContentPages?.forEach((contentPageKey: ContentPageKeys) => {
        store.dispatch(
          cmsLoadFlowCopy({contentPageKey})
        )
      })

      if (route.data.umbracoDynamicPagesConfig) {
        store.dispatch(
          loadDynamicPagesConfig()
        )
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      route.data?.umbracoFeatures?.forEach((featurePageKey: FeaturePageKeys) => {
        store.dispatch(
          cmsLoadFlowCopy({featurePageKey})
        )
      })

      return true;
    }),
  );
};
